module.exports = __webpack_public_path__ + "static/media/04-salesteam.ad289a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/03_Toppers-teams/04-salesteam.jpg
// module id = 740
// module chunks = 0